import './HomePageScreen.css';
import Hero from './components/Hero';
import MembershipBanner from '../../components/MembershipBanner';
import RecentEventsGrid from './components/RecentEventsGrid';
import RecentArticlesList from './components/RecentArticlesList';
import { useHomePage } from './hooks/useHomePage';
import { useNavigate } from 'react-router-dom';

function HomePageScreen() {
  const { events, articles, loading, error } = useHomePage({
    eventsLimit: 6,
    articlesLimit: 5
  });

  const navigate = useNavigate();

  const handleDiscoverClick = () => {
    navigate('/about');
  };

  const handleParticipateClick = () => {
    navigate('/contact');
  };

  return (
    <div className="homepage-screen">
      <Hero 
        onDiscoverClick={handleDiscoverClick}
        onParticipateClick={handleParticipateClick}
      />

      <section className="recent-content-section">
        <div className="recent-content-container">
          <RecentEventsGrid 
            events={events} 
            loading={loading} 
            error={error} 
          />
          <RecentArticlesList 
            articles={articles} 
            loading={loading} 
            error={error} 
          />
        </div>
      </section>

      <MembershipBanner />
    </div>
  );
}

export default HomePageScreen;
